/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocPlusIcon16Light } from './DocPlusIcon16Light';
import { DocPlusIcon16Regular } from './DocPlusIcon16Regular';
import { DocPlusIcon16Solid } from './DocPlusIcon16Solid';
import { DocPlusIcon20Light } from './DocPlusIcon20Light';
import { DocPlusIcon20Regular } from './DocPlusIcon20Regular';
import { DocPlusIcon20Solid } from './DocPlusIcon20Solid';
import { DocPlusIcon24Regular } from './DocPlusIcon24Regular';
import { DocPlusIcon24Solid } from './DocPlusIcon24Solid';
import { DocPlusIcon32Regular } from './DocPlusIcon32Regular';
import { DocPlusIcon64Regular } from './DocPlusIcon64Regular';
var sizes = {
    16: {
        light: DocPlusIcon16Light,
        regular: DocPlusIcon16Regular,
        solid: DocPlusIcon16Solid,
    },
    20: {
        light: DocPlusIcon20Light,
        regular: DocPlusIcon20Regular,
        solid: DocPlusIcon20Solid,
    },
    24: {
        regular: DocPlusIcon24Regular,
        solid: DocPlusIcon24Solid,
    },
    32: {
        regular: DocPlusIcon32Regular,
    },
    64: {
        regular: DocPlusIcon64Regular,
    },
};
export var DocPlusIcon = forwardRef('DocPlusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
